import { useTheme } from '@shopify/restyle';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { Theme } from 'app/shopify';

export function HowItWorksStep({
  emoji,
  label,
  outlined = false,
}: {
  emoji: string;
  label: string;
  outlined?: boolean;
}) {
  const theme = useTheme<Theme>();
  return (
    <Column alignItems="center" flex={1} gap="spacing.general.x2">
      <Row
        style={{
          width: 48,
          height: 48,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: outlined ? undefined : theme.colors['surface.tertiary'],
          borderRadius: 24,
          borderWidth: outlined ? 1 : undefined,
          borderColor: outlined ? '#D9D9D9' : undefined,
        }}
      >
        <Text fontSize={30} fontWeight="700">
          {emoji}
        </Text>
      </Row>
      <Text fontSize={11} textAlign="center">
        {label}
      </Text>
    </Column>
  );
}
